module.exports = __webpack_public_path__ + "static/img/state6.e5cd0980.png";